module.exports = __webpack_public_path__ + "img/71.79ab35f4.png";